export const cleanStoredData = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('access-token');
};
